/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CashSalaryIcon from "components/RevampFeedDetails/assets/CashSalaryIcon";
import CompanyImagePlaceholderIcon from "components/RevampFeedDetails/assets/ComapnyImagePlaceholderIcon";
import WorkFromHomeIcon from "components/RevampFeedDetails/assets/JobCardIcons/WorkFromHomeIcon";
import LocationPinIcon from "components/RevampFeedDetails/assets/LocationPinIcon";
import JobCardTags from "components/RevampFeedDetails/common/components/JobCardTags";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { useWindowResize } from "utils/hooks";
import config from "config";
import ChevronRightGrey from "assets/svgs/ChevronRightGrey";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import ChevronDownIcon from "components/RevampFeedDetails/assets/ChevronDownIcon";
import clsx from "clsx";
import { CircularProgress } from "@material-ui/core";
import { isUserLoggedIn } from "utils";
import useIsWebView from "modules/apnaAdvantage/utils/hooks/useIsWebView";
import { handleJobCardClick } from "utils/app-bridge";

// Revamp-todo: delete icons which are BE driven once testing is done. Path:assets/jobCardIcons in revamp folder
const SimilarJobsSection = ({
	similarJobs,
	category,
	similarJobsJoading,
	isInterviewPrepPage = false,
}) => {
	const [showMore, setShowMore] = useState(false);
	const [isMobileView] = useWindowResize();
	const isWebView = useIsWebView();

	useEffect(() => {
		trackOnMixpanel("Module Shown Web", {
			source: "Job Detail Page Web",
			type: "Similar Jobs",
		});
	}, []);
	const renderSalaryString = (jobDetails) => {
		if (jobDetails?.is_external_job) return "Not disclosed";

		const hasMinSalary = jobDetails?.min_salary || jobDetails?.min_salary === 0;
		const hasEarningPotential = !!jobDetails?.earning_potential;
		const hasIncentives = jobDetails?.is_incentives_involved;
		const isMonthlySalary = jobDetails?.salary_type === 2;

		if (hasEarningPotential) {
			// Only earning potential with incentives + monthly salary type
			if (hasIncentives && isMonthlySalary) {
				return `₹${jobDetails.earning_potential.toLocaleString()} monthly*`;
			}

			// Min salary + earning potential with incentives
			if (hasIncentives && hasMinSalary) {
				return `₹${jobDetails.min_salary.toLocaleString()} - ₹${jobDetails.earning_potential.toLocaleString()} monthly*`;
			}

			// Min salary + earning potential (no incentives)
			if (hasMinSalary) {
				return `₹${jobDetails.min_salary.toLocaleString()} - ₹${jobDetails.earning_potential.toLocaleString()} monthly`;
			}
		}

		return "";
	};
	const handleShowMoreClick = () => {
		setShowMore(true);
	};

	// Determine which jobs to display
	const getJobsToDisplay = () => {
		// For interview prep, follow show more logic only for web, always limit to 3 for WebView
		if (isInterviewPrepPage) {
			if (isWebView) return similarJobs?.slice(0, 3);
			return showMore ? similarJobs : similarJobs?.slice(0, 3);
		}

		// On mobile (non-interview prep), show all jobs
		if (isMobileView) return similarJobs;

		// On desktop, show all if expanded, otherwise limit to 3
		return showMore ? similarJobs : similarJobs?.slice(0, 3);
	};

	const handleCardClick = (job) => {
		// Track mixpanel events
		trackOnMixpanel("Module Clicked Web", {
			source: "Job Detail Page Web",
			type: "Similar Jobs",
		});

		trackOnMixpanel("Job Card Click", {
			source: "Similar job tab",
			"External Job Type": job?.is_external_job ? job?.job_info?.job_lead_type : "",
		});

		// If we're in webview, use app-bridge instead of standard navigation
		if (isWebView && isInterviewPrepPage) {
			// Pass job details as a JSON string to the app-bridge
			const jobDetailsString = JSON.stringify({
				jobId: job?.id,
				title: job?.title,
				organization: job?.organization?.name,
				publicUrl: job?.public_url,
				click_source: "interview_prep_similar_jobs",
			});

			handleJobCardClick(jobDetailsString);
			return;
		}

		// Standard navigation for web
		let urlString = `/${job?.public_url?.replace(config.websiteUrl, "")}`;

		if (isUserLoggedIn()) {
			urlString += `?c_id=${isUserLoggedIn()}`;
		}
		if (isMobileView) {
			window.open(urlString, "_self");
		} else {
			window.open(urlString, "_blank");
		}
	};

	// Loading state
	if (similarJobsJoading) {
		return (
			<div className="flex w-full items-center justify-center py-8">
				<CircularProgress style={{ color: "#1F8268" }} />
			</div>
		);
	}

	// No jobs state
	const jobsToDisplay = getJobsToDisplay();
	if (!jobsToDisplay?.length) return null;

	return (
		<div
			className={clsx(
				"border-[#E8E7EA]",
				{
					"rounded-lg bg-white": isInterviewPrepPage,
					"rounded-0 bg-[#EBF3FE]": !isInterviewPrepPage,
				},
				"md:rounded-xl md:border md:border-solid md:bg-white md:p-[16px]"
			)}
		>
			<div className="pl-[16px] pr-[16px] pt-[16px] text-md md:mb-0 md:p-0">
				<p
					className={clsx("m-0 font-semibold leading-[24px]", {
						"text-[#190A28]": isInterviewPrepPage,
						"text-[#003C96] md:text-[#123123]": !isInterviewPrepPage,
					})}
				>
					Similar jobs
				</p>
				{category && isMobileView && !isInterviewPrepPage && (
					<p className="m-0 text-xs leading-[24px] text-[#003C96] md:text-[#8C8594]">
						{category}
					</p>
				)}
			</div>
			{/* Job Cards */}
			<div className="scrollbarHide scrollbarHide::-webkit-scrollbar flex flex-col gap-[8px] overflow-x-scroll p-[12px] md:p-0">
				{jobsToDisplay.map((job) => (
					<React.Fragment key={job?.id}>
						<div
							className="w-full cursor-pointer space-y-[8px] rounded-lg border border-solid border-[#F4F2F6] bg-white p-[12px] shadow md:w-full md:max-w-[335px] md:border-0 md:p-0 md:pt-[16px] md:shadow-none"
							onClick={() => handleCardClick(job)}
						>
							{/* Company Header */}
							<div className="flex items-start justify-between">
								<div className="flex w-full items-center gap-[8px]">
									<div className="h-[32px] w-[32px] [&>svg]:h-[32px] [&>svg]:w-[32px]">
										{job?.organization?.logo_url ? (
											<Image
												height={32}
												width={32}
												src={job?.organization?.logo_url}
												className="rounded"
											/>
										) : (
											<CompanyImagePlaceholderIcon />
										)}
									</div>

									<div className="w-full max-w-[180px] flex-1 md:max-w-[220px]">
										<p className="m-0 truncate text-md font-semibold leading-[24px] text-[#190A28]">
											{job?.title}
										</p>
										<p className="m-0 truncate text-xs leading-[16px] text-[#8C8594]">
											{job?.organization?.name}
										</p>
									</div>
								</div>
								<ChevronRightGrey fill="#1F8268" />
							</div>

							{/* Job Details */}
							<div className="space-y-[4px]">
								{/* Location/WFH */}
								{job?.is_wfh ? (
									<div className="flex items-center gap-[4px]">
										<div className="flex h-[16px] w-[16px] items-center justify-center">
											<WorkFromHomeIcon />
										</div>
										<p className="m-0 text-sm text-[#8C8594]">
											Work from home
										</p>
									</div>
								) : (
									<div className="flex items-center gap-[4px]">
										<div className="flex h-[16px] w-[16px] items-center justify-center">
											<LocationPinIcon />
										</div>
										<p className="m-0 truncate text-sm text-[#8C8594]">
											{job?.location_name}
										</p>
									</div>
								)}

								{/* Salary */}
								{renderSalaryString(job) && (
									<div className="flex items-center gap-[4px]">
										<div className="flex h-[16px] w-[16px] items-center justify-center">
											<CashSalaryIcon />
										</div>
										<p className="m-0 truncate text-sm text-[#8C8594]">
											{renderSalaryString(job)}
										</p>
									</div>
								)}
							</div>

							{/* Tags */}
							<JobCardTags tags={job?.ui_tags} />
						</div>
						<div className="mt-[16px] hidden h-[1px] w-full bg-[#E8E7EA] last-of-type:hidden md:block" />
					</React.Fragment>
				))}
			</div>
			{!showMore &&
				similarJobs?.length > 3 &&
				(!isInterviewPrepPage || (isInterviewPrepPage && !isWebView)) && (
					<div
						className="mt-[16px] hidden cursor-pointer rounded bg-[#EAF8F4] px-[16px] py-[8px] text-[#1F8268] md:flex md:items-center md:justify-center md:gap-[4px]"
						onClick={handleShowMoreClick}
					>
						<p className="m-0 text-sm font-semibold">Show more</p>
						<ChevronDownIcon />
					</div>
				)}
		</div>
	);
};

export default SimilarJobsSection;
